import { getUrlParam } from '@/utils/utils';

import { post, get } from './ajax';

import { Message } from 'element-ui';

const IS_DEVELOPMENT_ENV = process.env.NODE_ENV === 'development';
const IS_PRODUCTION_ENV = process.env.NODE_ENV === 'production';
const user = localStorage.getItem('userId') ? localStorage.getItem('userId') : createUuid();
if (user) {
  localStorage.setItem('userId', user);
}

/**
 * 页面跳转
 * @param {string} pathname 路径跳转
 * @param {object} queryObj 路径跳转携带参数
 */
export function goToPage(pathname, queryObj = {}) {
  let pathSting = '';
  if (IS_DEVELOPMENT_ENV) {
    pathSting = `/${pathname}`;
  } else if (IS_PRODUCTION_ENV) {
    const path = location.pathname;
    const prefix = path.slice(0, path.lastIndexOf('/'));
    pathSting = `${prefix}/${pathname}.html`;
  }
  const queryString = Object.keys(queryObj)
    .reduce((prev, key) => [prev, `${key}=${queryObj[key]}`].join('&'), '')
    .slice(1);
  location.replace(`${location.origin}${pathSting}${queryString ? `?${queryString}` : ''}`);
}

/**
 * 获取语言
 * @returns language
 */
export function getLanguage() {
  let language = localStorage.getItem('trtc-tuiPlayer-language') || getUrlParam('lang') || navigator.language || 'zh';
  language = language.replace(/_/, '-').toLowerCase();

  if (language === 'zh-cn' || language === 'zh') {
    language = 'zh';
  } else if (language === 'en' || language === 'en-us' || language === 'en-GB') {
    language = 'en';
  }
  return language;
}

/**
 * 生成userName
 * return userName
 */

async function createUserName(liveId) {
  const params = {
    liveId,
    userId: user,
    role: 21,
  };
  const userName = sessionStorage.getItem(user);
  if (userName) return userName;
  const res = await post('/live/username/v1/make', params);
  if (res.code !== '0000') {
    return '观众';
  }
  sessionStorage.setItem(user, res.data);
  return res.data;
}

/**
 * 获取 UserInfo
 * @returns infodecode26
 */
export async function getUserInfo() {
  const info = getUrlParam('info');
  let infodecode;
  try {
    infodecode = JSON.parse(window.atob(info));
  } catch (err) {
    infodecode = {};
  }
  if (!infodecode.userName) {
    const userName = await createUserName(infodecode.liveId);
    infodecode.userName = userName;
  }
  !infodecode.userId && (infodecode.userId = user);
  return infodecode;
}

/**
 * 获取SecretKey
 * @returns sig
 */
export async function getSecretKey(data) {
  const { liveId = '', userId = '', userSig, privateMapKey } = await getUserInfo();
  if (userSig) {
    return {
      data: {
        userId,
        sign: userSig,
        errorCode: '0000',
        privilegeMap: privateMapKey,
      },
    };
  }
  // const { userId = '' } = getUserInfo();
  return post('/live/audienceguest/v1/makesign', { liveId, userId: userId ? userId : user, ...data });
}

/**
 * 格式化时间
 * @param date 时间类型的数据
 * @param formate 时间格式
 */

export function formatDate(dates, formats) {
  const date = new Date(Number(dates));
  let format = formats;
  const map = {
    M: date.getMonth() + 1, // 月份
    d: date.getDate(), // 日
    h: date.getHours(), // 小时
    m: date.getMinutes(), // 分
    s: date.getSeconds(), // 秒
    q: Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };
  if (!formats) {
    format = 'yyyy-MM-dd hh:mm:ss';
  }
  format = format.replace(/([yMdhmsqS])+/g, (all, t) => {
    let v = map[t];
    if (v !== undefined) {
      if (all.length > 1) {
        v = `0${v}`;
        v = v.substr(v.length - 2);
      }
      return v;
    } if (t === 'y') {
      return (`${date.getFullYear()}`).substr(4 - all.length);
    }
    return all;
  });
  return format;
}

export async function getDetail() {
  const { liveId = '' } = await getUserInfo();
  return get(`live/liveguest/v1/detail/${liveId}`).then((res) => {
    if (res.data.code === '0000') {
      return res.data.data;
    }
    Message.error(res.data.message);
    return {};
  });
}

export async function getBackDetail(data) {
  const { liveId = '' } = await getUserInfo();
  return post(`live/playbackguest/v1/detail`, {
    liveId,
    ...data,
  });
}

export async function getIMReq(liveId) {
  return get(`live/im/v1/list/${liveId}`);
}

export async function markReq(liveId, userId) {
  return post('live/v1/livevisit/mark', { liveId, userId });
}

/**
 * 生成一个uuid
 * @returns uuid
 */

export function createUuid() {
  /* eslint-disable */
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
